import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { EmployeeDTO } from "src/shared/api/generated/model/employeeDTO";

@Component({
  selector: "app-seniority-multi-select-dropdown",
  templateUrl: "./seniority-multi-select-dropdown.component.html",
  styleUrls: ["./seniority-multi-select-dropdown.component.scss"],
})
export class SeniorityMultiSelectDropdownComponent {
  @Output() shareCheckedList = new EventEmitter<any>();
  @Input() disabled: boolean = false;

  checkedSeniorities: Map<EmployeeDTO.SeniorityEnum, boolean> = new Map();
  showDropdown: boolean = false;

  constructor(private translateService: TranslateService) {}

  ngOnInit() {
    Object.values(EmployeeDTO.SeniorityEnum).forEach((value) => {
      this.checkedSeniorities.set(value, true);
    });
    this.shareCheckedlist();
  }

  getSelectedValue(status: boolean, value: EmployeeDTO.SeniorityEnum) {
    this.checkedSeniorities.set(value, status);
    if (!this.getCheckedCompanies().length) {
      this.checkedSeniorities.forEach((s, k) =>
        this.checkedSeniorities.set(k, true)
      );
    }
    this.shareCheckedlist();
  }

  getTranslatedCheckedCompanies() {
    return this.getCheckedCompanies().map((e) =>
      this.translateService.instant("employee.seniority." + e)
    );
  }

  getCheckedCompanies() {
    return Array.from(this.checkedSeniorities.entries())
      .filter((e) => e[1])
      .map((e) => e[0]);
  }

  shareCheckedlist() {
    this.shareCheckedList.emit(this.getCheckedCompanies());
  }
}
